import React from 'react'
import { PageSearch } from '../views/PageList'

export function SearchPage() {
  return <PageSearch />
}
